import { Switch } from "radix-ui";
import { useId } from "react";
import type { ControlName } from "./Checkbox.tsx";
import { cx } from "./tokens.ts";

export type ToggleProps = ControlName & {
  value: boolean;
  onChange: (value: boolean) => void;
  /** Not pressable; dimmed. */
  disabled?: boolean;
  testID: string;
};

/** On/off switch. With `label` it is a full row (label leading, switch trailing); with only `accessibilityLabel`, just the switch. */
export function Toggle({ value, onChange, label, accessibilityLabel, disabled, testID }: ToggleProps) {
  const id = useId();
  const control = (
    <Switch.Root
      id={id}
      className="b-switch"
      checked={value}
      onCheckedChange={onChange}
      disabled={disabled}
      aria-label={label === undefined ? accessibilityLabel : undefined}
      data-testid={testID}
    >
      <Switch.Thumb className="b-switch-thumb" />
    </Switch.Root>
  );
  if (label === undefined) return <div className={cx("b-control-row", "b-control-row-start", disabled === true && "b-control-disabled")}>{control}</div>;
  return (
    <div className={cx("b-control-row", disabled === true && "b-control-disabled")}>
      <label className="b-control-label" htmlFor={id}>
        {label}
      </label>
      {control}
    </div>
  );
}
